import { Component, OnInit } from '@angular/core';
import {Router } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SignConfirmComponent } from '../dialogs/sign-confirm/sign-confirm.component';
@Component({
  selector: 'app-download-app',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss']
})
export class DownloadAppComponent implements OnInit {

  constructor(private router: Router, public dialog: MatDialog) { }



  ngOnInit() {

   
  }

  openDialog() {
    const dialogRef = this.dialog.open(SignConfirmComponent,{panelClass: 'mobile-dialog-create',
      data: { name: "demande" }
    });
  }
    
}
